export default {
  common: {
    onlineComParty: '会议列表',
    onlineGalleryParty: '在线的画廊试图会议',
    onlineConferenceParty: '在线的发布会议',
    onlineKioskParty: '在线的展台会议',
    operationFailed: '启动音/视频失败，请检查话筒/摄像头',
    closeOperationFailed: '操作失败请重试.',
    repeatVoipJoined: '设备 {deviceId}({nickName}) 不能重复加入.',
    chromeSuggest: '为了更高的使用体验，强烈建议使用Chrome',
    gotIt: '确认',
    hostOperationMicroFailed: '麦克风打开失败，设备不可用',
    hostOperationCameraFailed: '摄像头打开失败，设备不可用',
    operationMicroFailed: '与会者的麦克风不可用',
    operationCameraFailed: '与会者的摄像头不可用',
    noData: '当前没有可用的源',
    shareFailed: '分享失败',
    shareFailHead: '分享失败原因:',
    shareFailText1: '1. 开放系统首选项→ 安全与隐私→ 隐私标签→ 屏幕录制',
    shareFailText2: '2. 如果应用程序复选框被锁定进行编辑，则需要单击左下角的锁定图标来解锁这些选项。单击标有“单击锁进行更改”的锁。出现提示时，输入管理员用户名和密码',
    shareFailText3: '3. 如果已经选中，请取消选中右侧列表中Google Chrome的复选框。如果出现提示，请选择“以后”',
    shareFailText4: '4. 选中刚才未选中的谷歌浏览器复选框。如果出现提示，请选择“退出并重新打开”',
    invitedExpire: '邀请已过期',
    stopPrivateByTalkback: '音频返送功能已开启, 当前的私聊已挂断.',
    mixMinusOn: '混音移除开: 在云视频中移出声音.',
    mixMinusOff: '混音移除关: 在云视频中保持声音.',
    mixMinus: '混音消除',
    noProgram: '暂无制作',
    noMainWinDowData: '暂无数据',
    noReceiver: '没有可用的直播设备',
    audience: '观众',
    audienceTips1: '· 观众可以接收来自会议里的视频画面和声音.',
    audienceTips2: '· 观众可以不提供他们的视频画面和声音.',
    audienceTips3: '· 观众可以通过“举手”和”私聊“功能和导播通话.',
    sendMediaRequest: '你的请求已发出.',
    operatPermission: '操作权限',
    mediaPopupText: ' 想修改你的麦克风/摄像头设备.',
    requestAgree: '请求控制麦克风/摄像头的请求已同意',
    requestDeny: '请求控制麦克风/摄像头的请求已拒绝.',
    setMicCameraSuccess: '麦克风/摄像头设置成功.',
    denySuccess: '拒绝成功.',
    setMicCameraFailed: '当前麦克风/摄像头不可用.',
    theHost: '主持人',
    selectAccount: '选择账号:',
    versionText: '展示版本在7.4以上并且在线的接收机',
    tagText: '设置后，在每一个会议中带有标记的与会者将被投放到主屏上',
    horizontalRow: '启用/禁用水平行',
    verticalRow: '启用/禁用垂直行',
    cellRow: '启用/禁用整个单元音频',
    encoderOperationFailed: '操作失败',
    moreIndex: '操作失败, 超过了最大使用个数 ({maxNumber}).',
    useReceiver: '已经在使用的有:',
    title: '会议名称',
    code: '会议ID',
    mode: '会议模式',
    email: '邮箱',
    operation: '操作',
    participantNumber: '与会者数量',
    stopSuccess: '停止成功',
    outputFailed: '输出失败. 请使用版本大于等于7641的接收机',
    tvuoneRemove: 'TVU One 只能移動到常规议会.',
    no: 'No.',
    mic: '麦克风',
    allFullScreen: '所有主屏进入全屏模式',
    allOutFullScreen: '所有主屏退出全屏模式',
    addParty: '添加会议到全局管理',
    failedInGlobal: '操作失败当前处于全局管理模式中',
    notAllowDelete: '不能删除当前正在用的全局会议',
    noGlobalText: '点击创建全局控制按钮去创建一个您的第一个作品.',
    applyAll: '发给所有人',
    nameIsRequired: '名字不能为空',
    applyAllTips: '设置所有会议使用全员主屏.',
    remark: '标记',
    validMute: '只允许静音会议',
    validMove: '移动与会者到另外一个会议',
    refreshData: '刷新列表',
    noGlobalData: '没有数据',
    noSelectParticipant: '请先选择你想移动的与会者.',
    repeatJoin: '重复加入',
    repeatContent: '当前账号已经在其他地方登入，如果想保留页面控制权，请刷新页面.',
    qrCodeText: '请在 TVU Anywhere 上扫描二维码',
    qrCodeText1: '请在 Partyline 应用上扫描二维码',
    slotSelection: '插槽选项',
    typeSelection: '类型选项',
    videoInput: '视频输入',
    audioInput: '音频输入',
    setDevicePermission: '媒体设备授权失败',
    deviceContent: '谷歌浏览器媒体设备授权弹框失败,请点击"继续"按钮授权.',
    continue: '继续',
    autoSwitchNewCameraSuccess: '自动切换摄像头成功',
    autoSwitchNewCameraFailed: '自动切换摄像头失败',
    autoSwitchNewMicSuccess: '自动切换麦克风成功',
    autoSwitchNewMicFailed: '自动切换麦克风失败',
    switchSpeakerSuccess: '自动切换扬声器成功',
    switchSpeaerFailed: '自动切换扬声器失败',
    supportR: '需版本>=7838',
    usageService: '用户服务',
    participateSetting: '参会设置',
    nickName: '用户名',
    partyMode: '会议模式',
    layout: '布局',
    startNow: '开始',
    userGuide: '指导手册',
    tvuPartyLine: 'TVU Partyline',
    partyList: '会议列表',
    blockAccount: '当前账号已经被锁定',
    maxNumber: '已达到参会者数量上限，其中包括与会者，大屏和屏幕分享',
    openAEC: '打开回声',
    openANS: '打开降噪',
    openAGC: '打开麦克风增强',
    refreshAffect: '注意: 刷新后生效.',
    dark: '深色',
    light: '浅色',
    theme: '主题',
    installAnyWhereText: '打开/安装 TVU Anywhere 应用程序',
    callupAnywhere: '唤醒 TVU Anywhere 应用',
    partylineManage: '会议管理',
    partylineJoin: '会议加入',
    partylinePreviewInit: '会议预览',
    partylinePreview: '会议预览 - {name}',
    partyTitle: '会议 - {name}',
    joinDeletParty: '当前会议已经被删除.',
    initCameraTips: '当前的设备 {name} 不能正常工作, 请切换其他可用设备',
    switchFailed: '切换当前设备失败.',
    initVideoTrack: '摄像头连接中请等待',
    stopPrivateFirst: '操作失败, 请先停止所有私聊.',
    checkAudioMsg: '当前是否正在说话? 你的麦克风处于静音状态. 点击麦克风按钮启用麦克风.',
    youMute: '你正在静音',
    rInOtherParty: '当前接收机在 {partyCode} 会议中',
    noAvailableDevice: '没有可用的{deviceType}设备',
    switchReceiverSource: '切换接收机视频源',
    receiverTips: '当接背包或者收机加入会议时, 会提供"视频输入"和"音频输入". 同时将接收所有与会者的声音',
    receiverPopText: '新添加的将取代具有相同视频输入的先前pip。请确认是否继续?',
    generateSummary: '生成总结报告',
    summary: '报告',
    inputLanguage: '输入语言:',
    leave: '离开',
    details: '详细信息',
    lastFrame: '最后一帧',
    empty: '空',
    copySlot: '复制视频 {index}',
    notAllowed: '请在会议中设置此功能.',
    sendSetting: '发送设置',
    noVailiableInput: '不可用，因为未检测到输入信号.',
    audioSetting: '音频设置',
    refreshSave: '刷新以保存',
    mono: '单声道',
    stereo: '立体声',
    audioAdvancedSettings: '音频高级设置',
    stereoNoOptions: '立体声不支持AEC ANS AGC 调节',
    audioFormat: '音频输出格式',
    audioQuality: '音频质量',
    noisTips: '降噪和音频增强',
    audioOutput: '音频输出格式与音频捕获有关。',
    selectTips: '如果捕获是单声道的，建议选择单声道。',
    aecTips: '回声消除',
    ansTips: '声音降噪',
    agcTips: '声音增益',
    stereoTips: '立体声控制',
    refreshToSave: '刷新保存生效',
    quicklyTalkFailed: '请不要频繁操作',
    pushTalkFailed: '请点击并且长按',
    pushTalkOnlyOne: 'Pushtalk按钮一次只能操作一个',
    micListChange: '麦克风列表发生了变化',
    switchMicSuccess: '切换麦克风设备成功',
    switchMicFailed: '切换麦克风设备失败',
    lazyAudioOpen: '单声道直播提示',
    liveAndLazyAudioText: '单声道直播功能已启用。接收器在开始直播后只会接收第一个单声道。',
    invalidPartyIdText: '会议ID不合法',
    notSupportSwitchSpeaker: '当前浏览器不支持切换扬声器.',
    showUploadImage: '显示上传的图片',
    waitingResult: '切换失败，请等待上一次接口返回.',
    voipNotOperateCamera: 'VoIP 不支持控制摄像头.'
  },
  debugPage: {
    title: 'PL Debug',
    partyCode: 'Party Code',
    join: 'Join',
    joined: '连接建立成功',
    notes: '注意: 此页面只有TVU用户可使用',
    leave: '离开',
    leaveSuccess: '离开成功',
    deprecatedTitle: '重要提示',
    deprecatedMessage: '此页面将被弃用并将重定向到Partyline管理员。请确保您拥有Partyline管理员权限。',
    redirectIn: '{seconds} 秒后自动跳转',
    jumpNow: '立即前往'
  },
  start: {
    getStarted: '开启互联',
    startParty: '开启互联',
    joinParty: '加入互联',
    join: '加入',
    cancel: '取消',
    placeholder: '请输入会议ID',
    partyId: '会议ID',
    startHead: '视频会议云协作解决方案',
    startText: 'TVU Partyline 是一个广播质量的云协作解决方案，以视频会议、画廊视图、会议和展台模式实时提供实时交互.',
    learnMore: '学习更多',
    learnMoreNext: ' 关于视频会议',
    joinPlaceholder: '会议 ID 或者会议分享链接'
  },
  endParty: {
    end: '结束会议',
    title: '结束会议',
    content1: '您确定要结束会议吗？',
    content2:
      '如果结束会议，所有的直播流都将被中断，聊天会话会被清除。',
    cancel: '取消',
    save: '确认'
  },
  chatM: {
    chat: '聊天',
    publicRoom: '公聊频道',
    groupChat: '群聊',
    personalRoom: '私聊频道',
    newMessage: '新频道',
    sendEveryone: '和大家一起交流',
    message: '发消息给',
    searchPart: '搜索参会者名称',
    chatSet: '聊天设置',
    chatNote: '注意："结束会议"会清空历史聊天信息。',
    lockPri: '锁定私聊',
    lockPub: '锁定公聊',
    sendM: '发送消息',
    toopPri: '一旦锁定私聊后，参会者只能接收信息，或发送给主持人。',
    tooPub: '一旦锁定公聊后，参会者只能接收信息，不能发送信息。',
    moreChat: '同一时间只支持在一个会议聊天'
  },
  Movepips: {
    movepip: '移动参会者',
    cancelOperations: '取消批量操作',
    selectAll: '全选',
    cancel: '取消',
    done: ' 确认',
    selected: '个已选中',
    moveTo: '移动至',
    cancelMove: '取消',
    save: '确认',
    moveTips: {
      title: '移动操作',
      cancel: '取消',
      save: '移动'
    }
  },
  copy: {
    onCopy: '复制成功',
    onError: '复制失败',
    rename: '重命名成功'
  },
  invite: {
    receivedCohost: '收到的邀请',
    invite: '邀请',
    getLink: '链接',
    shareTo: '分享给',
    copyLink: '复制链接',
    saveInvite: '保存',
    anyoneJoin: '任何人可通过链接加入会议',
    onlyUserJoin: '仅已添加至列表的用户可加入会议',
    onlyByPasscode: '通过密码加入会议',
    emailNotation: '邮件通知',
    emailCorrectly: '请输入正确的邮箱地址。',
    clearUp: '清楚',
    remove: '移除',
    inviteCohoster: '添加主持人搭档',
    invitePlaceholder: '添加参会者的邮箱',
    inviteSetSuccess: '设置成功',
    inviteSetCopySuccess: '设置成功,密码已复制',
    inviteDeleteSuccess: '删除成功',
    passCode: '密码',
    copyPassCode: '复制密码',
    passWordText: '要求6位密码',
    plsInpPasscode: '请输入密码',
    setPasscodeSuccess: '设置密码成功',
    wrongPasscodeFormat: '请输入正确的密码格式',
    alreadyInvited: ' 已经邀请过了',
    inviteEndParty: '结束会议',
    unBind: '接触绑定: 未指定管理人员.',
    accountAssociation: '账户关联',
    accountAssociationText: '为每个接收者分配一个管理帐户并共享参与方链接，然后该帐户可以访问相应的Station UI。',
    canNotBandHostEmail: '不能绑定主持人账号。'
  },
  personalInfo: {
    receivedCohostTextSecond: '除了 "删除会议" 和添加 "主持人搭档".',
    receivedCohostTextOne: '当前的人将会和会议管理员拥有相同的权限',
    partyName: '会议名字',
    receivedCohost: '主持人搭档',
    lang: '语言',
    logOut: '退出登录',
    login: '登录',
    register: '注册',
    collaborate: '合作',
    inviteCollaborators: '邀请列表',
    receivedInvites: '受邀列表',
    applicant: '申请人',
    inviteationTime: '邀请时间',
    addEmailTile: '添加邮箱后',
    liveWithAccount: '- 可以和所添加过的账号进行直播.',
    moveAccount: '- 可以移动与会者到所添加的账号.',
    pullAccount: '- 您可以将云导播 PGM 从添加的帐户拉到主窗口.',
    popupTitle: '和其他创建者合作',
    noInvitedEmail: '请输入你想邀请的邮箱.',
    inviting: '邀请中',
    declined: '拒绝',
    Permission: '权限',
    accept: '接受',
    acceptSuccess: '成功接受，申请人将能够与您分享他的视频源',
    acceptCancel: '成功拒绝，申请人将无法与您共享其视频源',
    acceptHostSuccess: '成功接受, 你将拥有与会议拥有者相同的管理权限',
    acceptHostCancel: '成功拒绝',
    decline: '拒绝',
    acceptedRequest: '接受请求',
    acceptedCoHostRequestText: '你将拥有与会议拥有者相同的管理权限',
    declineCoHostRequestText: '您已拒绝申请,你可以修改电子邮件中的按钮接受请求',
    RequestCoHostExpiredText: '请求已经存在如果想继续此次操作请联系申请人',
    acceptedRequestText: '申请人将可以和你的云导播进行直播或者添加与会者到你的云视频.',
    declineRequestText: '您已拒绝申请，申请人将无法向您分享其信息来源.',
    declineRequest: '拒绝请求',
    RequestExpired: '请求已经存在',
    RequestExpiredText: '请求已经存在如果想继续此次操作请联系申请人',
    removeInvitedMe: ' 已经取消他/她对你的邀请.',
    hostRemoveInvited: ' 已经取消对你的邀请',
    accepted: ' 已经接受你的邀请',
    hostSaveSuccess: '邮件请求已经发送到用户',
    forbidSetting: '禁止设置自己的邮箱',
    refuseInvite: ' 已经拒绝你的邀请',
    hadInvited: '当前的邮箱已经邀请过了.',
    hadCoHostInvited: '该用户已经是主持人搭档.',
    pending: '等待接受中',
    account: '账号',
    collaboratePopupTitle: '邀请分享你的视频到云导播和云互联服务',
    collaboratePopupLike: ' 是否同意成为一名协作者',
    cohostPopupLike: '想添加你成为',
    cohostPopupParty: '会议的主持人搭档.',
    collaboratePopupAllow: '允许事项如下:',
    collaboratePopupDetail1: '· 申请人可以和你的云导播进行直播操作.',
    collaboratePopupDetail2: '· 申请人可以添加视频源到你的云导播中.',
    collaboratePopupDetail3: '· 声请人可以把你的云导播作为视频输出出去.',
    cohostPopupDetail1: '· 该会议将会出现在你的会议列表中.',
    cohostPopupDetail2: '· 你将拥有与会议拥有者相同的管理权限.',
    backToWorkBench: '返回至会议管理'
  },
  commonPartyHost: {
    topContent: {
      partyName: '会议名称',
      partyId: '会议ID',
      copy: '复制',
      endParty: '结束会议',
      send: '发送',
      partyOwner: '会议主持人'
    },
    leftPane: {
      title: {
        party: '常规会议',
        group: '画廊视图',
        coordinator: '发布会',
        kiosk: '展台',
        arena: '竞技场',
        globalControl: '多会议',
        station: '电台',
        interview: '采访'
      },
      sorting: '排序方式',
      date: '日期',
      name: '名称',
      type0: '日期',
      type1: '名称',
      coHost: '主持人搭档',
      type2: '全局控制',
      partyOperation: {
        rename: '重命名',
        copyLink: '复制链接',
        lock: '锁定参会者名称',
        unlock: '解锁参会者名称',
        invitation: '邀请规则',
        partySetting: '会议设置',
        hide: '隐藏参会者页面的邀请按钮',
        show: '展示参会者页面的邀请按钮',
        loginHide: '隐藏参会者页面的全屏和登入按钮',
        loginShow: '显示参会者页面的全屏和登入按钮',
        delete: '删除',
        remove: '从全局控制中删除',
        AddCoHost: '添加主持人搭档',
        ReceiverCoHost: '收到的邀请',
        deleteCoHost: '删除主持人搭档',
        addParty: '添加会议'
      },
      party: '创建一个常规会议',
      group: '创建一个画廊视图',
      conference: '创建一个发布会',
      kiosk: '创建一个展台模式',
      globalControl: '创建一个多会议模式'
    },
    turnOffInterview: '关闭私聊',
    turnOnInterview: '打开私聊',
    turnOnIntercom: '打开双向对讲机(私聊)',
    turnOffIntercom: '关闭对讲机(私聊)',
    turnOnMessage: '发起者和接收者的声音不会被其他人听见.',
    turnOffMessage: '双方将会停止私聊.',
    notAllowedStop: '只有主持人能停止私聊.',
    hostTurnOffOneWay: '你可以停止单方向和与会者的私聊.',
    outsideText: '不在私聊的人都将会听见你的声音.',
    hostTurnOnOneWay: '你可以重新发起和与会者的单向私聊.',
    outsideText1: '私聊外的其他人将听不见你的声音.',
    turnOnOneWayIntercom: '打开单向对讲机(私聊)',
    turnOffOneWayIntercom: '关闭单向对讲机(私聊)',
    stopBoth: '两边都将停止私聊.',
    allowPrivate: '你可以开始内部通话.',
    notAllowPrivate: '主播关闭了内部通话，之前的所有通话都将被关闭.',
    receiveTwoWayPrivate: '{nickName} 和你开启双向通话.',
    receiveOneWayPrivate: '{nickName} 和你开启单向通话.',
    cancelOneWayPrivate: '{nickName} 结束和你的单向通话.',
    cancelTwoWayPrivate: '{nickName} 结束和你的双向通话.',
    sendTwoWayPrivate: '你和 {nickName} 开启了双向通话.',
    sendOneWayPrivate: '你和 {nickname} 开启了单向通话',
    endTwoWayPrivate: '你结束了和{nickName}的双向通话.',
    endOneWayPrivate: '你结束了和{nickName}的单向通话.',
    switchDeviceFailed: '请稍后再尝试切换.',
    addPip: '请邀请与会者加入',
    sendPrivate: '已开启对讲功能，该与会者将与您进行通话.',
    endPrivate: '您已关闭通话功能.',
    turnOnIntercommunicate: '已建立内部通话，关联的人员可相互通话.',
    turnOffIntercommunicate: '已断开内部通话.'
  },
  mainWindow: {
    noSource: '暂无视频源',
    noVideoReturn: '暂无视频源',
    establishContact: '与云导播配合使用：',
    sameAccount: `1. Producer 和 ${$cm.title} 登录同一个账号。`,
    synchronize: `2. Producer 的 PGM 会同步至 ${$cm.title} 的主屏。`,
    none: '无',
    producerPgm: 'Producer 节目输出',
    receiverVF: '接收机返送视频',
    success: '连接成功',
    mainW: '主屏',
    producer: '云导播',
    sourceFromWindow: '来自于主持人的主屏资源',
    tagMainWindow: '被标记的与会者位于各自会议的主屏上',
    unpin: '取消固定',
    unpinTips: '点击取消上大屏.',
    dobluClick: '双击视频'
  },
  addTvuOne: {
    add: `${$cm.tvuoneCn}`,
    autoAdd: '自动添加',
    addToP: '添加至常规会议',
    receiverSettingTitle: '接收机设置',
    producerSettingTitle: '云导播设置',
    channelSettingTitle: '频道设置',
    placeholder: '搜索名称或者ID',
    tvuone: 'TVU 设备',
    inThe: '已经加入',
    theTvuOne: 'TVU 设备',
    chooseAll: '全部添加',
    selected: '已选',
    adds: '添加',
    adding: '添加中',
    remove: '移除',
    next: '下一步',
    deviceVersion: '该设备“{hwName}: {build}不支持”,版本要求{supportedBuild}+',
    TestedDevices: '测试设备',
    mediaHub: 'TVU 云调度',
    receiver: '接收机',
    pack: 'TVU 背包',
    producer: '云导播',
    channel: '频道',
    all: '全部',
    online: '在线',
    offline: '离线',
    recover: '自动可恢复',
    voip: '本机声音',
    noAudio: '无声音',
    tvuoneSettingTitle: '背包设置',
    recoveryTips: '在关闭后保留TVU设备(需要手动移除或会议派对)',
    deviceOffline: '当前设备不在线',
    deviceInParty: '当前设备在 {partyCode}',
    removeTips: '从自动恢复列表删除，并且会保留在会议中.',
    autoRecoverTips: '通过这种方式添加的设备具有自动恢复功能，这意味着如果设备离线后重新上线，而没有被手动移除，它将自动回到原有的网络中.',
    packVoIPTip: 'TVUOne 将通过其 3.5 毫米连接器加入聚会，其输出将接收所有参与者的音频.',
    receiverVoIPTip: '接收机将通过其前置放大器输入加入聚会.接收机版本.',
    receiverVoIPTip1: '在前置放大器输出端,它将接收所有参与者的音频.',
    recevierVersion: '接收机 8.1 版本',
    switchPackSource: '切换背包源',
    switchContent: '当前的设备已经加入到会议 {partyCode}, 是否想切换到当前会议?',
    deviceHadJoin: '当前设备已经被加入到会议 "{partyList}"',
    hasAlreadyJoin: '相同配置的设备不能重复加入.',
    removing: '正在离开中...',
    confrimRestart: '是否要重启编码',
    hasSelectedNumber: '已经选择 {number} 个设备',
    joinMultiRFailed: '设备 {rNameLiist} 加入失败',
    confirmSwitch: '是否想要切换到当前会议?',
    notSupportVoIP: '当前的版本是 { version} 不支持 VoIP 功能',
    autoDuck: 'Auto Duck',
    duckLevel: 'Duck level:',
    autoDuckTitle: '启用该选项后，你可以确定在检测到对侧通道上存在音频时，将自动回到哪个声道。',
    notSupportControl: '暂不支持控制背包和接收机的媒体设备.'
  },
  shareScreen: {
    share: '共享屏幕'
  },
  commonSetting: {
    participantSetting: '参会者设置',
    resolution: '分辨率',
    high: '高',
    low: '低',
    lazyAudio: '单声道直播',
    on: '开',
    off: '关',
    cloudProxy: '云代理',
    vfbSetting: '返送视频设置',
    framerate: '帧率（fps）',
    default: '默认',
    bitrate: '比特率',
    lazyContent: '开启之后，会在每一个参会者视频显示单声道直播按钮',
    onLazyAudioTip: '已打开单声道直播，其他参会者将听不到该视频源。',
    offLazyAudioTips: '关闭单声道直播',
    onLocalLazyAUdioTip: '已打开单声道直播(Ctrl+L)，其他参会者将听不到该视频源。',
    offLocalLazyAUdioTip: '关闭单声道直播(Ctrl+L)',
    turnOnLazy: '打开后，参会者视频源直播时，仅推送声道2的音频',
    ctrlL: 'Ctrl+L',
    hostLazyDisableTips: '点击过后发送给接收机的声音将从左声道变为右声道.',
    hostLazyOnTips: '点击过后发送给接收机的声音将从右声道变为左声道.',
    lazyAudioLTips: '· 开启直播时, 只发送左声道的声音给接收机.',
    lazyAudioRTips: '· 开启直播时, 只发送右声道的声音给接收机.',
    click: '· 点击',
    lazyAudioLText: '它并且在直播时，只发送右声道的声音给接收机.',
    lazyAudioRText: '它并且在直播时，只发送左声道的声音给接收机.',
    lOutputToR: '"左声道" 将会发送给接收机.',
    rOutputToR: '"右声道" 将会发送给接收机并且其他人听不见视频声音.',
    cannotHear: '· 参会者听不见你说的话.'
  },
  operationBtn: {
    AudioOnlyEnabled: '仅音频模式已启用',
    on: '开启',
    off: '关闭',
    camera: '摄像头',
    microphone: '麦克风',
    speaker: '扬声器',
    selectMicrophone: '选择一个麦克风',
    selectSpeaker: '选择扬声器',
    selectCamera: '选择一个摄像头',
    shareScreen: '屏幕分享',
    stopShareScreen: '停止屏幕分享',
    chat: '文字聊天',
    voice: '声音内容',
    tagExplain: '收到全局控制的命令后,带标签的与会者将上主屏幕',
    notAllowed: '声音矩阵开启的时候不允许用私聊功能.',
    deviceBlock: '{deviceType}被系统禁用.',
    voipTips: 'VoIP: 此功能是与会者和接收机双向通话',
    notStopLive: '背包离开会议时不会停止直播.'
  },
  btnText: {
    rename: {
      text: '重命名'
    },
    removeParticipant: {
      text: '移除参会者'
    },
    setCrew: {
      text: '导播沟通员'
    },
    cancelCrew: {
      text: '参会者'
    },
    startPrivateConversation: {
      text: '创建私聊'
    },
    cancelPrivateConversation: {
      text: '挂断私聊'
    },
    replace: {
      text: '替换'
    },
    roleSetting: {
      text: '指定角色'
    },
    setSpeaker: {
      text: '主讲人'
    },
    cancelSpeaker: {
      text: '参会者'
    },
    cancelQuestionSpeaker: {
      text: '参会者'
    },
    hangUpInterview: {
      text: '结束提问'
    },
    setQuestionSpeaker: {
      text: '采访者'
    },
    interviewer: {
      text: '采访者'
    },
    setPublicTalk: {
      text: '设为采访者'
    },
    cancelQuestioner: {
      text: '参会者'
    },
    cancelQuestionerRemove: {
      text: '移除提问者队列'
    },
    setQuestioner: {
      text: '参会者'
    },
    addQuestioner: {
      text: '加入提问者队列'
    },
    toTop: {
      text: 'To top'
    },
    participant: {
      text: '参会者'
    },
    denyRaiseHand: {
      text: '移出举手队列'
    },
    setBroadcast: {
      text: '广播员'
    },
    setPublicSpeaker: {
      text: '公共发言人'
    },
    editTagName: {
      text: '编辑标签名'
    },
    fullScreen: {
      text: '全屏'
    },
    moveParty: {
      text: '移动至'
    },
    SetTag: {
      text: '标记为主屏'
    },
    CancelTag: {
      text: '取消标记'
    },
    anyWhereSetting: {
      text: '设置'
    },
    setting: {
      text: '设置'
    },
    mainwindow: {
      text: '成为主窗口'
    },
    unMainwindow: {
      text: '取消成为主窗口'
    },
    uploadImage: {
      text: '上传图片'
    },
    fromComputer: {
      text: '从计算机上传'
    },
    formImageGallery: {
      text: '从图片库上传'
    }
  },
  tagName: {
    editTagName: '标签名设置',
    tagInfo: '标签名仅您可见。',
    tagName: '标签名',
    add: '添加标签名',
    del: '删除',
    sub: '确认'
  },
  startNewParty: {
    partyNumber: '参会人数',
    contents: '在常规会议里，可以设置参会者的最大数量。',
    defaulltParticipants: '30名参会者（默认）',
    cancel: '取消',
    apply: '确认',
    participantSetting: '参会设置',
    participantSettingSucceTips: '参会设置成功',
    name: '名称',
    corporation: '公司',
    submit: '提交',
    on: '开',
    off: '关',
    participantSettingSuccessful: '参会设置已修改成功',
    participantNameSuccessful: '参会者名称已修改成功',
    createSuccessful: '创建成功'
  },
  removeParty: {
    removeS: '移除参会者成功',
    removeF: '移除参会者失败'
  },
  deleteParty: {
    delS: '删除会议成功',
    delF: '删除会议失败'
  },
  pushParticipantSource: {
    destination: '选择返送视频源',
    specialDestination: '选择目的地',
    success: '开启直播成功',
    failed: '开启直播失败',
    stopLive: '停止直播成功',
    switchLive: '推流覆盖',
    cancel: '取消',
    confirm: '确认',
    content1: '当前，该台接收机正在和',
    content2: '直播,您是否想中断它，并和本路视频流直播？',
    outputContent1: '当前接收机正在和',
    outputContent2: '推流， 您是否想中断并切换到当前会议推流.'
  },
  authorizeOperation: {
    authorize: '授权操作',
    success: '授权成功',
    removeS: '移除成功',
    failed: '授权失败',
    ok: '确认',
    content: '当',
    content1: '被设定为"导播沟通员"时，他可以创建私人对话。',
    switchNewRole: '切换"导播沟通员"',
    switchConfirm: '您确定将"Production Crew"更换为',
    role: '角色'
  },
  audioChannels: {
    audioChannels: '音频声道',
    rvt: '接收机设置',
    audioSetting: '云导播设置',
    liveSource: '当前直播源',
    stereo: '立体声',
    mutiple: '多声道',
    cancel: '取消',
    send: '确认',
    stop: '停止',
    gallery: '画廊',
    gotIt: '确定'
  },
  partylineGuest: {
    leave: '离开会议',
    isSharing: '正在共享屏幕',
    limitation: '主持人搭档数量已达到3的限制',
    endPartyNotice: '主持人已结束会议',
    removeFromParty: '你已经被移出会议',
    backHome: '回到首页',
    createPrivateConversation: '创建私聊成功',
    privateConversationHung: '挂断私聊成功',
    switchPrivateCon: '更换私聊对象',
    hungContent: '开启新的私聊之后，当前的私聊会被挂断。您确认要更换吗？',
    save: '确认',
    cancel: '取消'
  },
  galleryHost: {
    output: '输出',
    Default: '当前直播源',
    group: '当前直播源',
    send: '传输',
    stop: '停止',
    preview: '预览主屏',
    sharing: '正在共享屏幕',
    shareScreen: '共享屏幕',
    sendSucc: '传输成功',
    sendFailed: '传输失败',
    stopSucc: '停止传输成功',
    outputPlaceholder: '选择多画面输出目的地',
    nameOperation: '参会者名称设置',
    nameOperationCon: '展示参会者的名称',
    cancel: '取消',
    ok: '确认',
    operationS: '输出成功',
    stopOperationS: '停止输出成功',
    fillInRule: '填充规则',
    rulesDes: '画廊视图输出时，空闲位置的填充规则',
    autoFilled: '按照等待顺序自动填充',
    donotRe: '保留最后一帧不变',
    copySLot: '不进行替换并且替换空的位置为你选择的',
    chooseWho: '手动选择想要替换的位置',
    setSuccess: '设置成功',
    fullScreen: '全屏模式',
    exitFullScreen: '退出全屏模式',
    changeSuccess: '布局调整成功',
    talkWithEach: '相互交谈',
    noReplace: '请选择你想替换位置的人',
    privateChatQueue: '私人聊天请求队列',
    selectOneToChat: '在队列中选择一个参会者创建私聊',
    queueNoParti: '无交流申请',
    privateChannel: '私人空间通道',
    done: '完成',
    talk: '交流',
    hangUp: 'Hang up',
    privateRequestRemove: '私聊申请已被拒绝。',
    privateRequestSet: '私聊已开始。',
    netWorkPoor: '网络不佳，请刷新页面。',
    privateChatHungUp: '私聊已挂断',
    replaceParticipant: '替换参会者',
    seated: '已就坐',
    waiting: '等待队列',
    noParticipant: '没有可替换的参会者。',
    yesRe: '确认替换',
    no: '取消替换',
    replace: '替换',
    replaceOne: '你想要替换对方的位置吗?',
    replaceTwo: '在当前位置，所选pip将被替换为当前pip。继续吗?',
    replaceSuccessful: '替换成功',
    renameParty: '会议重命名成功',
    renamePartyFailed: '会议重命名失败',
    endedPartySuccess: '结束会议成功',
    movePaticipant: '参会者确定要移动至',
    movePipTips: '你确定要将参会者移动至',
    movePartySuccess: '转移参会者成功',
    moveSuccessExpectTagger: '除了被标记的人，所有人都被移动成功.',
    movePartyFailed: '转移参会者失败',
    broadCaster: '广播员',
    broadcasterTips: '每个人都能看到和听到该视频源。',
    StopBroadcast: '停止广播',
    publicSpeaker: '公共发言人',
    fontName: '字体',
    fontNamePlaceholder: '请选择字体',
    imageGallery: '图片库',
    imageList: '图片列表'
  },
  galleryParticipant: {
    hideMe: '隐藏我',
    showMe: '显示我',
    applyChat: '申请和主持人私聊',
    sendChatRequst: '私聊申请已发送。',
    removeChatRequest: '私聊申请已撤销。',
    privateConversaitonEnd: '私聊已结束',
    publicSpeaker: '现在，您是"公开发言人"。',
    nowSpeaker: '是公开发言人',
    websiteSoundOff: '网站声音关闭',
    websiteSoundOn: '网站声音开启',
    cameraTips: '操作权限',
    gotIt: '好的',
    deny: '拒绝',
    admit: '允许',
    cameraTipCon: '主持人想打开你的摄像头',
    fullParticipatnes: '我们的会议人数暂时已满，请稍后尝试，感谢您的参加'
  },
  conferenceHost: {
    muteSite: '网站静音',
    mute: '静音',
    mainWindow: '主屏',
    Speaker: '主讲人',
    selectSource: '选择视频源',
    None: '无',
    producerPgm: 'Producer 节目输出',
    VideoFeedBack: '返送视频',
    noSpeakerDesign: '暂未指定主讲人',
    noSpeakerMessage: '请等待主持人开始视频返送',
    designSpeaker: '在主讲人下拉列表中选择一位主讲人',
    noQuestionerDesign: '暂未指定提问者',
    designQuestioner: '在采访者队列中选择一位采访者',
    questionerQueue: '采访者队列',
    selectSpeaker: '选择主讲人',
    selectVfb: '选择返送视频',
    setSpeakerSuccess: '指定主讲人成功',
    setPgmSuccess: '传输成功',
    setPgmFailed: '传输失败',
    setQuestionerSuccess: '指定提问者成功',
    setQuestionerFailed: '指定提问者失败',
    setQuestionQueue: '加入提问者队列成功',
    removeQuestionQueue: '移出举手队列成功',
    raisedHandQueue: '举手队列',
    num: '人数',
    handQueuePar: '参会者',
    handQueueParCoporation: '公司',
    handQueueParOperation: '操作',
    receiverVf: '接收机反送视频'
  },
  conferenceParticipant: {
    offCamera: '关闭摄像头',
    onCamera: '打开摄像头',
    offMicrophone: '关闭麦克风',
    onMicrophone: '打开麦克风',
    applyPubHost: '向主持人申请公聊',
    applyPubHostTips: '私聊请求已发送',
    cancelApplyPubHostTips: '私聊请求已取消',
    publicTalk: '公聊',
    leaveParty: '离开会议',
    areYouOk: '你确定要离开会议吗？',
    cancel: '取消',
    leave: '离开'
  },
  kioskHost: {
    Tag: '标记',
    VFB: '返送视频',
    PP: '云导播',
    PIP: '与会者',
    pip: '与会者',
    pipOne: '与会者',
    pbpTwo: '画外画(2名与会者)',
    PBP: '画外画',
    broadCasterPip: '广播员',
    speakerPip: '主讲人',
    Broadcaster: '广播员',
    Speaker: '主讲人',
    shareScreen: '屏幕分享',
    displayLocation: '展示位置',
    asPip: '作为参会者',
    asMainWinddow: '作为主屏',
    me: '我',
    exitFullScreen: '退出全屏模式',
    addBack: '添加背景/Logo',
    done: '完成',
    logo: 'Logo',
    background: '背景',
    placingPositionSetting: '布局设置',
    imageList: '素材列表',
    choosePositionOfPicture: '请选择图片的布局。',
    bottomSide: '底部',
    rightSide: '右侧',
    renameSuccessful: '重命名成功',
    renameFailed: '重命名失败',
    requestHasBeenSend: '请求已经发送，正在等待批准',
    requestDeny: '你的请求已经被拒绝了',
    selectSource: '选择源',
    selectLeftSource: '选择左边的源',
    selectRightSource: '选择右边的源',
    setBackGroundS: '设置背景图片成功',
    setLogoS: '设置Logo图片成功',
    selectImg: '选择要上传的图片',
    uploadLogo: '上传图片',
    displayArea: '图片显示区域',
    imageFormat: '图片格式',
    maxSize: '每张最大10MB',
    uploadBtnText: '点击上传图片',
    useDefaultLogo: '使用默认logo',
    sourceType: '来源类型',
    vfbSource: '返送视频',
    ppSource: '云导播',
    shareSource: '屏幕分享',
    confirmTodelete: '您确认要删除它吗？',
    cannotDelete: '当前的图片正在使用中不能被删除.',
    deleteUploadImage: '确定要删除上传图片?',
    deleteUploadImg: '删除Logo 图片',
    yes: '确认',
    operateImageFailed: '操作失败，当前图片正在使用中',
    operateImageFailedPip: '操作失败，当前的Logo已经被设置到与会者端了',
    saveSuccess: '上传成功',
    deleteSuccess: '删除成功',
    deleteBackgroundImg: '删除背景图片',
    pbpErrorPopup: '请先停止当前的主屏直播',
    muteAllMic: '全员静音',
    muteMic: '禁用麦克风',
    unmuteAllMic: '取消全员静音',
    unmute: '取消禁用麦克风',
    unmuteMic: '取消禁用麦克风',
    allFullScreen: '全员全屏',
    allOutFullScreen: '退出全员全屏',
    toAllParty: '推送视频到所有会议:',
    globalControl: '全局控制',
    editGroupFootText: '选择要添加到全局控制的会议.',
    hadSelected: ' 选择',
    addToGlobalControl: '添加到全局管理',
    controlName: '全局管理名称',
    partySelect: '已选择: ',
    controlSelectPlac: '选择已存在的或者创建一个新的',
    notEnough: '选择会议的数量要大于等于2个',
    fullScreenAuth: '全屏授权',
    fullScreenAuthText: '是否允许进行全屏操作',
    tagInput: '带有标签的与会者将投放在主屏上'
  },
  responeInfo: {
    tryAgain: '{errorCode}: 请稍后再试',
    maximumParty: '超过最大会议创建数 ',
    wsConnected: 'WebSocket连接成功',
    wsDisconnected: '未连接，正在连接...'
  },
  commonFunction: {
    Owner: '拥有者',
    CoHost: '主持人搭档',
    mirror: '远程镜像：它将在本地和接收端同时生效',
    localMirror: '本地镜像：它将在本地预览中生效',
    rotate: '旋转 90°',
    bottomDown: '隐藏底部菜单栏',
    bottomUp: '显示底部菜单栏',
    MuteHostSound: '静止主持人的声音',
    corporationRequired: '公司名必填',
    nameRequired: '名称必填',
    notOperateFrequery: '请勿频繁操作。',
    operateSuccessful: '操作成功',
    operateFailed: '操作失败',
    reconnecting: '重新连线中……',
    hideInviteButtonTips: '共享链接被隐藏，参会者将无法看到复制按钮',
    showInviteButtonTips: '共享链接显示出来，参会者将能够看到复制按钮',
    hideFullScreenLoginButton: '登入和全屏按钮已经隐藏，参与者将无法看到这两个按钮',
    showFullScreenLoginButton: '登入和全屏按钮已经显示，参与者将能看到这两个按钮',
    switchToParty: '切换至会议',
    changeLayout: '切换布局',
    switchMainWindow: '切换主屏内容',
    mainWindowSource: '主屏正在播放源，你真的想要把播放源切换成屏幕共享吗？',
    broadcasterSource: '主屏正在播放源，你真的想要把播放源切换成广播员吗？',
    autoPlayFailed: '浏览器暂停了视频自动播放是否要恢复播放',
    switch: '确认',
    cancel: '取消',
    pictureInpicture: '画中画',
    crewReason: '因为有成员在工作',
    host: '主持人',
    participant: '参会者',
    broadCaster: '现在，您是"广播员"。',
    isBroadCaster: '是广播员',
    privateConversation: '主持人向你发起了一个私人会话',
    newPrivateConversation: '{nickName} 正在和你进行私聊.',
    cancelPrivateConversation: '{nickName} 已经结束内部通话.',
    enableIntercom: '你允许开启私聊功能',
    disableIntercom: '主播关闭了私聊功能并且所有的私聊功能都将停止.',
    someOneRemoveYou: '有人将你移除会议了',
    hasCameraOff: '主持人关闭了你的摄像头',
    hasMicrophoneOff: '主持人关闭了你的麦克风',
    hasMicrophoneOn: '主持人打开了你的麦克风',
    crewTips: '操作失败，你得到成员许可，可以直接和主持人对话',
    crewMessage: '操作失败，你正在对话中',
    privateMessage: '操作失败，你正在私聊中。',
    operateBroadcaster: '操作失败，你现在是广播员',
    operatePublicSpeaker: '操作失败，你现在是公共发言人',
    addSource: '添加源',
    contactWithProducer: '和Producer建立联系',
    contactFirstOne: `Producer 和 ${$cm.title} 账号保持一致`,
    contactSecondOne: `Producer 节目输出将在${$cm.title}同步。`,
    noReceiverTips: '没有任何接收器/节目输出，请先在Producer中创建一个程序',
    participantTips: '参会者开启了会话，请等待参会者关闭再来开启私人会话。',
    pushTalkTips: '当前开启了对讲功能，如果想开启私聊请先关闭对讲功能.',
    currentSoure: '当前源',
    isOffline: '下线了',
    isNotCamera: '没有开摄像头',
    isOn: '在 ',
    party: ' 会议',
    addCommonParty: '添加至常规会议',
    commonParty: '常规会议',
    waitingLoading: '加载中，请稍等……',
    soundOfSite: '网站声音',
    noAccess: '无法访问',
    audio: '音频',
    addDeviceFailed: '当前的设备{deviceName}添加失败({reason})'
  },
  remainWords: {
    liveBookTitle: '一旦参与者加入，直播将自动开始',
    liveBook: '直播预约',
    shareScreenTips: '如果你想要共享屏幕，请先停止广播',
    stopClick: '请点击"停止共享"按钮来暂停屏幕共享',
    anotherSharing: '另外一个主持人正在分享屏幕',
    hostModifyParticipant: '主持人已经修改了你的参会者设置',
    hostHasMicrophoneOn: '主持人打开了你的麦克风',
    operationTalking: '操作失败，你正在讲话',
    pushToAudioMixer: '你将会被推送至混音',
    stopPushAudioMixer: '你将会被停止推送至混音',
    hostModifyParticipantName: '主持人已修改您的与者名称。',
    hostLockParticipantName: '不能更改的主持人锁定参会者的名称。',
    hostUnlockParticipantName: '可以更改主持人未锁定的参会者名称',
    hostChangeAudioLevel: '音量效果已切换为视频窗口上的音量条。',
    hostChangeAudioBar: '音量效果已切换为麦克风图标上的音频效果。',
    supportphoneToBroadcaster: '不支持电话成为广播者或发言人',
    partyNotExist: '会议不存在',
    someOneSharing: '有人正在分享',
    enterId: '会议不存在，请联系会议主持人',
    deletedParty: '会议不存在',
    switchPublicSetting: '切换至私人聊天',
    switchPublicWords: '设置新的会话后，当前的私人聊天将被挂断。你确认要继续吗?',
    goOn: '继续',
    currentLocalNetWorks: '您的网络连接不稳定，这可能会影响您的体验。建议刷新浏览器，重新连接。',
    noResults: '没有结果',
    noRunning: '没有可用的制作',
    noDevices: '没有可用的设备',
    participantCamera: '参会者的摄像头不可用。',
    site: '本网页',
    audioPlayPolicy: '音频自动播放策略',
    allow: '允许',
    audioContents: '由于浏览器限制音频自动播放，请点击"允许"按钮接收音频。',
    abnormalMixing: '不正常的混音',
    refresh: '刷新',
    audioMixingAbnormal: '由于不稳定的newtork，您的音频混合不正常，请刷新页面。',
    tvuoneVersions: '· 支持所有,',
    supportedDevices: '支持的设备有',
    tvuoneVersionsOne: '版本如下',
    tvuoneVersionsTwo: 'V2: 7561+,',
    tvuoneVersionThree: 'V3: 74066+,',
    tvuoneVersionFour: 'MLinkV7: 71062+',
    tvuoneVersionFifth: '· 不支持4K Pack加入会议',
    for: '因为',
    underAccount: '在账户下',
    live: '直播',
    edit: '编辑',
    sectionName: '片段名称',
    noSectionCreated: '没有创建任何片段',
    canvasTips: '在一个接收器上创建画布',
    restartVfb: '重新启动反送视频',
    restartVfbSuccuss: '重新启动反送视频成功',
    setSuccess: '设置成功'
  },
  arenaMode: {
    noCanvansCreated: '无画布',
    unLockParty: '未锁定会议',
    lockPartyAndApproach: '锁定本竞技场',
    createCanvans: '创建画布',
    rename: '重命名',
    startNewParty: '创建新的竞技场',
    title: '锁定会议和路径',
    continue: '继续',
    onceUnLockTheParty: '一旦解锁这个会议：',
    guestNotJoinParty: '观众将不能进入这个竞技场',
    joinedParticipant: '已经加入的参会者将会离开这个会议',
    liveTerminated: '所有的直播将会被终止',
    onceLockTheParty: '一旦锁定本竞技场：',
    guestJoinParty: '观众将可以进入竞技场，',
    canotModify: '且您将无法编辑画布。',
    lockPartySuccess: '锁定会议成功',
    unLockPartySuccess: '解锁会议成功',
    deleteTips: '你真的想要删除这个会议吗？',
    afterEnd: '删除之后:',
    deleContentTips: '所有的数据都会被清掉并且会议会消失',
    deleteParty: '删除会议',
    createCanvansTitle: '基于接收机创建画布',
    canvansName: '画布名称',
    receiver: '接收机',
    selectReceiver: '选择接收机',
    inputSeatNumber: '请设置单屏的观众数量',
    row: '行',
    column: '列',
    selectLayOut: '选择布局',
    sectionList: '分区列表',
    createSection: '创建区',
    sectionA: 'A区',
    canvansCreateTips: '操作失败，一个画布可以创建六个最大的模块。',
    nameEmptyTips: '名称不能为空。',
    createCanvansSuccess: '创建画布成功',
    receiverName: '接收机名称',
    areanaSelectReceiver: '选择接收机',
    sendToGuest: '发送给参会者',
    sendGuestSuccess: '发送给参会者成功',
    preview: '预览',
    deletePartySuccess: '删除会议成功'
  },
  addWords: {
    copyLinkTips: `请点击链接加入${$cm.title}: \n`,
    turnOnTalkback: '开启"内部交流"',
    turnOffTalkback: '关闭"内部交流"',
    commentatorAbnormalNet: '网络不稳定！由于网络不稳定的原因，您目前没有和项目同步，请刷新或检查您的网络',
    noEvent: '暂无活动',
    noEventTips: '没有活动的视频',
    stopShareScreenTip: '请先停止共享屏幕',
    turnOnLazyAudio: '已开启单声道直播',
    turnOffLazyAudio: '已关闭单声道直播',
    sureDelParty: '你确定要删除这个会议？',
    cancelCohost: '主持人取消了您的协调员身份。',
    failToJainParty: '加入会议失败',
    fullParty: '参会人数已达上限: ',
    noPermission: '无授权',
    participantPassCode: '参会密码',
    enterPassWord: '输入参会密码',
    caseSensitive: '密码区分大小写',
    accountNotAllowed: '您的账号尚未得到主持人的授权。请先联系主持人。',
    bandWidth: '带宽质量',
    stopCrewFailed: '停止最后一个成员失败',
    commonPartyLimits: '常规会议成员超出限制',
    failToTalkBack: '打开失败，云导播不支持这个功能。',
    producerNotSupport: '云导播不支持这个功能。',
    productionCrew: '现在，您是导播沟通员，可以开始与其他人进行私人聊天。',
    notSelectCurrentSource: '你不能选择目前这个源，因为目前这个源是公共发言人',
    vfbSwitchToShare: '主屏正在播放源，你真的想要把播放源切换成屏幕共享吗？',
    shareSwitchToVfb: '正在使用主持人的屏幕，你想要切换成返送视频吗？'
  },
  joinPartyWays: {
    clickMenu: '点击上方的菜单',
    openWays: '请使用Safari或者Google浏览器去打开它',
    joinPartyWithBrowser: '如果下载和通过Anywhere加入有问题',
    accessByBrowser: '通过浏览器加入',
    or: '或者',
    notInstallText: '如果当前没有安装 TVU Anywhere 应用程序，请点击按钮下载.',
    joinPartyLine: '打开 TVU Anywhere 应用',
    hadInstallAnywhereText: '如果您已经安装了 TVU Anywhere 应用，请在浏览器对话框中单击 [打开] 按钮；或者单击下面的按钮.',
    toInstallAnyWhere: `点击“前往应用商店下载”，即可下载安装${$cm.app}`,
    downLoadFromStore: '前往应用商店下载'
  },
  netWorkStatus: {
    Good: '良好',
    Poor: '较差',
    Mid: '一般',
    AutoAudioOnly: '自动设置音频模式',
    AutoAudioText: '如果当前网络下行不好时会自动开启订阅音频',
    AllTimeAudioOnly: '只订阅音频模式',
    AllTimeAudioText: '只订阅音频',
    AudioDisabled: '关闭订阅音频模式',
    disabelAUdioPopup: '关闭订阅音频模式，并且将一直加载视频.',
    AudioOnlyDisabledText: '音频订阅模式一直不启用.',
    poorNetworkPopup: '当前网络状态不好，开启只订阅音频，当前视频将不会被加载',
    AllTimeAudioPopup: '开启只订阅音频模式并且将不再订阅视频流',
    saveBandWIdth: '节省带宽设置',
    stillWantToLoad: '选择想要继续加载的视频:',
    MainWindow: '主屏',
    pinnWindow: '固定窗口',
    SharedScreen: '屏幕分享',
    Disabled: '禁用',
    operationIncludes: '选项包括:',
    mainwindowByHost: '主播设置的大屏',
    leftRightWindow: '左右布局的大屏'
  },
  setting: {
    OpenGlobalAnyWhere: '打开TVU Anywhere的全局设置',
    OffGlobalAnyWhere: '关闭TVU Anywhere的全局设置',
    globalAnywhereSetting: 'TVU Anywhere的全局设置',
    globalAnywhereSettingText: '该配置将立即对所有TVU Anywhere参与者生效。它们仍然可以单独控制。',
    participantSetting: '参会者设置',
    mainWindowSetting: '主屏设置',
    devicesSetting: 'TVU 设备设置',
    settingName: '设置',
    helpCenter: '帮助',
    mutexPrompt: '当使用“{featureName}”时，此功能不可用',
    participantTitle: '设置所有参会者的相关功能',
    titleNote: '仅支持控制中心接收机和导播台接收机',
    note: '注意:',
    volumeNote1: '声音控制 - 7.7或者低于7.7版本的接收机只支持对正在直播的源设置',
    volumeNote2: '声音控制 - 接收机版本大于等于7.8的支持对直播的源和SDI输入设置',
    mainwindowTips: '当会议里面没有人时，主屏将会在半个小时后关闭',
    mainWindowTitle: '设置本会议的主屏参数或者设备参数',
    shareScreenTitle: '设置对会议里所有与会者生效.',
    audioMatrixSetting: '声音矩阵设置',
    participantAudioText: '你可以控制你和其他与会者声音',
    participantSettingText: '允许与会者控制他们自己的声音矩阵',
    blueAudioMatrixIcon: '不互通!你可以单方面听到他们.',
    yellowAudioMatrixIcon: '不互通!他们可以单方面听到你',
    changeParticipants: '与会者发生改变.',
    maximize: '最大化',
    minimize: '最小化',
    redAudioMatrixIcon: '双方互相听不见',
    schematic: '示意图',
    interpretationChart: '解释图',
    audioOut: '垂直方向表示“音频输出”.',
    audioOutText: '垂直方向的人将“音频输出”给相应水平方向的人.',
    audioIn: '水平方向表示“音频输入”.',
    audioInText: '水平方向的人从相应的垂直方向的人那里接收“音频输入”.',
    turnOffs: '当关闭时,',
    turnOffTips: '· 所有的与会者都可以相互听见',
    turnOns: '当打开时,',
    turnOnTips: '· 你可以手动设置彼此是否能相互听见',
    noteTips: '· 注意：功能开启时私聊功能将被关闭.',
    generalControl: '基本设置',
    participantName: '参会者名称',
    intercom: '通话 (私聊)',
    volimeEffect: '音量效果',
    turnOff: '关闭后：',
    turnOn: '开启后：',
    lockName: '会议里的所有参会者将无法修改他们的参会名。',
    aiSpeech: '将在所有参与者页面的底部显示“AI 语音转文字”按钮。AI 语音将识别所有参与者所说的内容',
    openParticipantPrivat: '所有与会者(除了 TVU anywhere 应用)都将可以和其他人私聊。',
    partyLink: '会议链接分享',
    lockCopy: '会议里的所有参会者页面将隐藏复制会议链接的按钮。',
    fullScreen: '全屏按钮',
    loginAndRegister: '登录/注册按钮',
    muteAll: '全部静音',
    muteAllTips1: '一次性操作',
    muteAllTips2: '每次点击都会静音所有与会者',
    muteAllSuccess: '全部禁用成功',
    muteAllParticipantsTips: '主持人关闭了你的麦克风',
    loginButton: '会议里的所有参会者页面将隐藏“登录/注册”',
    loginFunction: '按钮。',
    hotJar: '会议里的所有参会者（包括主持人）页面将隐藏',
    collectTool: '收集用户反馈的工具。',
    liveTool: '直播聊天工具.',
    advanceControl: '高级设置',
    highResolution: '高分辨率',
    turnOnHighResolution: '开启后，所有参会者将使用高分辨率：',
    selectHighResolution: '系统会基于网络状态选择合适的分辨率。',
    turnOffHighResolution: '关闭后，所有参会者将使用低分辨率：',
    defaultResolution: '默认是低分辨率。',
    lazyAudioOn: '参会者窗口会出现单声道直播的控制按钮，主持人和参会者都能控制',
    terminalReceiver: '如果Lazy Audio关闭，左音频通道将输出到接收机',
    otherParticipantHear: '如果Lazy Audio打开，右音频通道将输出到接收机，其他参与者不会听到',
    audioFeedBack: '音频返送（参会者能听到自己的声音）',
    hearThemselves: '会议里通过浏览器加入的参会者能够在交流时听到自己的声音。',
    fullScreenTips: '会议里的所有参会者下方的全屏按钮都会被隐藏。',
    micAndCamera: '参会者小窗口的麦克风和摄像头显示',
    micAndCameraTips: '参会者页面的小窗口将不显示麦克风和摄像头的图标。',
    volume: '源音量',
    pipVolume: '与会者音量',
    volumeHint: '更改编码的VFB流的音量。这将是参与者能够听到的最大价值。',
    volumePipHint: '更改所有与会者和主持人主窗口上音频控件的默认值。与会者可以根据需要修改音量。',
    adjustedVloume: '主持人已调整音量',
    defaultBitrate: '30(默认)',
    notHearSelfTips: '麦克风关闭的时候听不见自己的声音',
    offAudioFeedBack: '关闭音频返送',
    onAudioFeedBack: '打开音频返送就可以听见自己的声音',
    loginShownMessage: '显示参会者的登录或者注册按钮',
    loginHiddenMessage: '隐藏参会者的登录或者注册按钮',
    fullScreenShowMessage: '显示参会者底部的全屏按钮',
    fullScreenHiddenMessage: '隐藏参会者底部的全屏按钮',
    micAndCameraShowMessage: '显示参会者小窗口的麦克风和摄像头的图标',
    micAndCameraHiddenMessage: '隐藏参会者小窗口的麦克风和摄像头的图标',
    hotJarShowMessage: '显示参会者的HotJar',
    hotJarHiddenMessage: '隐藏参会者的HotJar',
    chatlioShowMessage: '与会者 Chatlio 已显示',
    chatlioHideMessage: '与会者 Chatlio 显示已关闭',
    audioBackOperateSuccess: '操作成功',
    bitrateMessage: '比特率的最小值是200/比特率的最大值是5000',
    minVolumeMessage: '音量最大值是100',
    mainWindowSaveMessage: '设置成功',
    onCloud: '云代理已开启',
    offCloud: '云代理已关闭',
    proxySetting: '代理设置',
    whatCloudProxy: '什么是"云代理设置"?',
    restructed: '与云代理的受限网络连接',
    canEnableDescribe: '您可以启用云代理，以确保参与者从具有受限网络的环境进行连接时能够可靠连接',
    onPipSideDescribe: '在与会者方面，他们必须已配置防火墙以允许通过云代理进行通信',
    howEnableCloudProxy: '如何开启"云代理设置"',
    stepONeDescribe: '步骤1：主持人需要保持开关按钮打开',
    stepTwoDescribe: '步骤2：受限网络中的与会者和主持人需要将以下IP和端口添加到其企业防火墙的白名单中',
    contactEmailContent: '如果您有任何问题，请通过电子邮件与我们联系：',
    contactFeatureContent: '如果您想使用这个功能，请通过电子邮件与我们联系：',
    contactEmail: 'support@tvunetworks.com',
    audioMatrix: '音频矩阵',
    ShareScreenSetting: '分享视频设置',
    aiSpeechSetting: '人工智能语音识别',
    cloudProxy: '云代理',
    configureWhitelist: '建议根据端口白名单进行配置。',
    receiverRegion: '区域',
    northAmerica: '北美',
    europe: '欧洲',
    india: '印度',
    japan: '日本',
    southEastAsia: '东南亚',
    china: '中国',
    cloudProxyIpRange: '云代理IP范围',
    cloudProxyPort: '云代理端口',
    accessPointIpRange: '接入点IP范围',
    accessPort: '接入端口',
    receiverConfigureAvailable: '可使用已配置好端口的接收机。',
    lockNameTips: '参会者名字已被锁定了',
    unlockNameTips: '参会者名字未锁定',
    OnHighResolution: '开启高分辨率',
    OffHighResolution: '关闭高分辨率',
    nextUse: '下次使用生效',
    intercomNote: '注意: 一旦关闭私聊会使当前正在私聊的参与者私聊结束.',
    meterOnPip: '音量柱模式',
    audioLevel: '麦克风图标模式',
    speechLowQuality: '语音低质量 速率 16Khz, 比特率 24Kbps)',
    speechStandard: '语音标准 (速率 32Khz, 比特率 24Kbps)',
    musicStandrad: '音乐标准(速率 48Khz, 比特率 32Kbps)',
    highQuality: '高质量 (速率 128Khz, 比特率 128Kbps)',
    standardStereo: '标准立体声 (速率 48Khz, 比特率 64Kbps)',
    highQualityStereo: '高质量立体声 (速率 48Khz, 比特率 192Kbps)',
    reStartEffectMsg: '会议中的设备不会自动更改格式，如果想要其生效，请先移除在重新添加到会议',
    deviceLeaveRules: '设备离开规则',
    deviceLeaveContent: '设备将在指定时间内离开当会议中没有与会者时.',
    immediately: '立刻',
    oneHour: '一小时',
    twoHour: '两小时',
    twentyFourHour: '24 小时',
    customize: '定制'
  },
  partyInfo: {
    cohostLimit: '最多只能有10个co-host 同时在线',
    partylineDetail: '常规会议模式旨在允许远程(和分布式)视频制作团队和工作人员进行协作和互动',
    GalleryViewDetail: '画廊视图模式可以将所有参会者放置在特定的网络布局中，并将其投影置大屏幕。',
    conferenceDetail: '发布会模式可配置为主持虚拟采访、新闻发布会、市政厅或其他教育活动',
    kioskDetail: '展台模式允许您创建具有不同背景和徽标的自定义体验，突出显示主窗口作为中心显示',
    globalControlDetail: '多会议模式允许单个工作人员从中央界面管理多方',
    partyline: '常规会议',
    GalleryView: '画廊视图',
    conference: '发布会',
    kiosk: '展台',
    globalControl: '多会议',
    inputLevel: '输入水平',
    startTesting: '开始测试',
    stopTesting: '停止测试',
    note: '注意:如果你能听到自己的声音，那么麦克风工作正常',
    MicrophoneSelection: '麦克风选项',
    MicTest: '麦克风测试',
    testMic: '测试你的麦克风',
    createTime: '创建时间',
    partyID: '会议ID',
    host: '管理者',
    cohost: '主持人搭档',
    joinNow: '加入',
    history: '历史记录',
    startTime: '开始时间',
    endTime: '结束时间',
    duration: '持续时间',
    minutes: '分钟',
    searchPlaceHolder: '会议名字/会议ID',
    maxLimit: '最大数量限制',
    noPartyCode: '没有可以加入会议的ID',
    joinFailed: '请在继续之前输入您的昵称和会议名称',
    nameCannotEmpty: '请输入昵称.',
    tvu: 'TVU',
    notNeedVideo: '当前页面不需要设置摄像头.',
    partylineTitle: 'Partyline',
    manage: '管理',
    maxPips: '最大与会者数量',
    editSubParty: '修改子会议',
    switchOutput: '切换输出源',
    notConnect: '无法建立链接,正在尝试中...',
    partyState: '会议状态',
    disableParty: '关闭会议',
    enableParty: '开启会议',
    enable: '开启',
    disable: '关闭',
    disableMean: '关闭会议意味着，当前会议仍然存在只是不可以使用，直到主持人重新开启会议".',
    disableConfrimText: '确定想要开启不可用功能吗?',
    enableMena: '“开启会议” 意味着会议将会打开,任何人都可以重新加入.',
    enableConfrimText: '是否想开启会议?',
    unableJoin: '无法加入',
    deletedParty: '会议ID不存在',
    partyDisable: '当前可能已经被删除或者不存在.',
    partyDisabled: '当前会议已经关闭',
    inputNumber: '请输入正确的数字',
    rightValue: '请输入一个正确的比特率数值范围是200到5000.',
    modifyMaxPip: '当前会议状态为可加入,不可以修改最大与会者人数.',
    cancelInvited: '主持人取消了对你的邀请.',
    rejoin: '重新加入'
  },
  aiSpeech: {
    diabledTitle: '该功能不可用',
    openAiSpeech: 'Open AI Speech',
    start: '开始识别语音',
    stop: '停止语音识别',
    title: 'AI 人声识别',
    translateInto: '翻译为',
    download: '下载',
    mainwindow: '主屏',
    webParticipants: '网页端与会者',
    tvuAnywhereParticipants: 'TVU Anywhere app 与会者',
    receiverParticipants: '接收机与会者',
    tvuOneParticipants: '背包与会者',
    tvuAppParticipants: 'TVU Partyline app 与会者',
    mediaParticipants: '云调度与会者',
    helpTips: '选择要显示的文本类型源',
    me: '我',
    notSupportCopy: 'The browser does not support copying text to the clipboard.',
    copySuccess: '复制成功',
    copyFail: '复制失败',
    aiAssistant: 'AI 助手',
    aiSummary: 'AI 摘要',
    getSummaryFailed: '获取摘要失败',
    executeSuccess: '执行成功',
    executeFailed: '执行失败',
    selectPP: '云导播制作',
    translate: '翻译',
    noContentSummary: '暂无可总结的内容',
    aiPolicyTitle: 'AI语音转文本',
    aiPolicyGeneratedText: 'AI语音转文本使用AI技术，其中可能包括第三方模型。主持人和参与者的演讲可以被识别并显示为文本，并且可以生成聚会摘要。',
    aiPolicyModelText: 'TVU Partyline不会使用任何音频、视频、聊天、屏幕共享或其他通信内容来训练TVU Partyline或第三方Al模型。',
    aiPolicyAccuracyText: 'Al生成的内容可能不准确或具有误导性。始终检查准确性。',
    sendByEmail: '发送到邮箱',
    sendBySlack: '发送到 Slack',
    errorEmail: '错误的邮箱格式',
    sendEmailTips: 'AI摘要将按照以下设置的地址发送。',
    sendEmailTips2: '聚会结束后，AI摘要将自动发送到列表.',
    sendSlackTips: '你可以从Slack频道详情或Slack用户详情中获取Slack邮箱地址，并在这里添加它.',
    noTranscript: '没有可生成的摘要.',
    emailSaving: '正在保存邮箱...',
    emailSaved: '邮箱保存成功.',
    deleteEmailSuccess: '删除邮箱成功.',
    notInputLan: '请先选择一个输入语言.',
    English: '英语',
    Chinese: '中文',
    Korean: '韩语',
    Japanese: '日语',
    Spanish: '西班牙语',
    Portugues: '葡萄牙语',
    French: '法语'
  },
  micMutedInfo: {
    title: '麦克风不可用',
    ignore: '忽略',
    contentTitle: '您的麦克风已被系统设置静音.',
    contentMessage: '去计算机的设置以取消麦克风静音并调整其音量.',
    openBtnMes: '打开声音设置'
  },
  voiceCommand: {
    title: '人工智能语音助手',
    tips: '可以通过语音命令执行操作。',
    step1: '步骤1:',
    step1Text: '设置与会者去执行语音操控',
    magicWord: 'Hey Bot',
    step2: '步骤2:',
    step2Text: '请确认当前要使用的云导播是哪个.',
    step3: '步骤3:',
    step3Text: '唤醒机器人通过关键词指令.',
    step4: '步骤 4:',
    step4Text: '使用以下推荐的语音命令，让机器人执行相应操作.',
    SelectProducerProgram: '选择云导播:',
    defaultText: '尝试说“设置 slot 作为 PGM”',
    voiceSend: '语音操控命令正在发送, 请等待...',
    sendSuccess: '命令执行成功!',
    sendFailed: '很抱歉我没有听懂，请在说一遍.',
    programNotExists: '请选择一个正在工作的云导播.',
    voiceWord: '推荐语音词',
    action: '操作',
    switchPgm: '切换视频/源成为 PGM',
    switchPvw: '切换视频/源成为 PVW',
    cutPvwToPGm: '切 PVW 成为 PGM',
    curOverlayToPgm: '剪切覆盖为 PGM',
    setSlotAsPvm: '设置插槽几成为 PVW',
    setSlotAsPgm: '设置 slot 作为 PGM',
    selectParticipant: '选择与会者:',
    summaryGenerate: '正在生成 AI 摘要，请稍等...',
    summaryTime: '摘要的数据时间为 ',
    participantNoProductId: '当前没有云导播制作ID，请联系导播去选择一个云导播制作ID'
  },
  anywhereSetting: {
    tvuAnywhere: 'TVU Anywhere App',
    partylineApp: 'Partyline App',
    pid: 'PID',
    missProperties: '此TVUA不支持远程控制',
    setting: '远程设置',
    framesRate: '帧速率',
    switchCamera: '切换相机',
    switchMic: '切换麦克风',
    defaultView: '默认视图',
    balance: '白平衡设置',
    scenes: '场景',
    temperature: '色温',
    tints: '色调',
    lockApp: '锁定{deceiveType}应用程序',
    lockApps: '锁定TVU Anywhere应用程序',
    autoFocus: '自动对焦',
    autoExposure: '自动曝光',
    exposureValue: '曝光值',
    focusValue: '对焦值',
    scenesTips: '为不同场景选择白平衡参数',
    lockAppTips: '一旦锁定，{deceiveType}用户就无法对其页面进行任何操作。',
    lockAppTitle: '一旦锁定，TVU Anywhere用户就无法对其页面进行任何操作。',
    zoomText: '缩放',
    speakerText: '扬声器音量',
    positionTips: '在连接云台之后，可以预设两个固定位置以便快速应用。',
    positionText: '预设位置',
    positionOne: '位置_1',
    positionTwo: '位置_2',
    positionSetting: '位置设置',
    positionBtnDisabledTips: '请在使用前在“设置”中设置位置信息。',
    positionBtnActiveTips: '点击将位置应用到应用程序中。',
    manualSet: '手动设置',
    preposition: '预设设置',
    prepositionName: '预设位置',
    upDown: '上 / 下:',
    leftRight: '左 / 右:',
    del: '取消',
    save: '保存',
    reset: '重置',
    autoWhiteBalance: '自动白平衡',
    userLeft: '此TVU Anywhere参会者已离开会议',
    'Selfie (Front-facing Camera)': '自拍 (前置摄像头)',
    'Main (Rear Camera)': '主摄像头（后置摄像头)',
    'Main+Selfie (distant view)': '主页 + 自拍 (远景)',
    'Main+Selfie (near view)': '主页 + 自拍 (近景)',
    fullScreen: '全屏',
    partylineView: '会议视角',
    prePosition: '操作失败，请重新设置预设值'
  },
  pushTalk: {
    pushTalk: '按键通话',
    breakoutRoom: 'Breakout Room',
    people: '人',
    noMembers: '没有与会者',
    room: '组',
    pushTalkTips: '可以创建和管理聊天组',
    enableParticipants: '允许与会者去控制他们的对讲功能',
    muteAudio: '启用按键通话时，将静音输出音频',
    manageTips: '管理“通话”群组:',
    rename: '重命名',
    assign: '分配',
    delete: '删除',
    shortCut: '与会者排序在主页上，单击并按住快捷方式[index]以启用此“小组讨论”按钮。',
    notAllowed: '操作失败，请先停止声音矩阵和对讲机功能',
    groupTips1: '1. 组创建者将有相应的“小组通话”按钮.',
    groupTips2: '2. 长按按钮仅与该组中的参与者交谈.',
    deleteGroupText: '确认删除分组会议室吗?',
    deleteGroup: '删除分组会议室',
    deleteParticipant: '删除与会者',
    deleteParticipantText: '确认要把与会者从分组中删除吗?',
    move: '移动',
    moveTitle: '移动与会者到:',
    puskTalkFootTips: '点击并长按 {index} 可以和 “{groupName}” 讲话',
    groupName: '组的名字:',
    inputName: '请输入分组名称',
    createGroup: '创建分组',
    create: '创建',
    participantHolder: '搜与与会者名字',
    notSupport: 'TVU Anywhere与会者当前不支持该功能。',
    enterGroupName: '请输入群组名称'
  },
  detail: {
    deviceName: '设备名称',
    deviceType: '设备类型',
    devicePid: '设备ID',
    deviceVersion: '设备版本',
    programName: '节目名称',
    tvuOne: '背包',
    tvuReceiver: '接收机',
    tvuProducer: '云导播',
    tvuChaneel: '频道',
    tvuCloudR: '云接收机'
  },
  intercom: {
    intercom: '对讲机',
    talent: '现场人员',
    station: '电台',
    stations: '电台',
    sessionName: '会话名字',
    click: '点击',
    copy: '复制',
    buttonInvite: '按钮去邀请',
    partylineApp: '应用',
    users: '使用者',
    addPack: '按钮我添加设备.',
    addReceiver: '按钮添加接收机设备.',
    talkToAll: '发起所有人通话',
    userId: '用户 ID:',
    bottomTips1: '选择一个人和电台，点击 “ 连接” 按钮去建立双向通话',
    bottomTips2: '与此同时你将会听到他们的谈话.',
    talentTips: '生产现场设备清单.',
    stationTips: '电台制作人清单.',
    copied: '已复制',
    copyUserId: '复制使用者 ID',
    voip: '语音通话',
    app: 'App',
    packSdi: '背包 SDI/HDMI',
    receiveSdi: '接收机 SDI/HDMI',
    connectTo: '正在和 {deviceName} 连接',
    creator: '创建者:',
    searchPepole: '搜索名字',
    searchStation: '搜索电台',
    session: '会话',
    createSession: '创建会话',
    status: '状态',
    speaker: '扬声器',
    operation: '操作',
    notSelectStation: '请在创建组之前先选择一个电台.',
    active: '· 活跃',
    inactive: '非活跃',
    createGroupSuccess: '创建组成功',
    deleteSessionTitle: '删除会话',
    deleteSessionText: '确定要删除当前会话吗?',
    talkToAllTalents: '和所有人通话',
    cannotSwitchStation: '如果你想切换电台，请先点击活跃按钮去停止状态.',
    changeSessionName: '更改回话名称',
    sessionNameEmpty: '会话名称不能为空.',
    onlyOneActive: '只允许有一个会话开启活跃状态.',
    noSession: '请先选择一个会话.',
    removeParticipant: '从房间中移除',
    cannotDeleteSession: '当前会话处于活跃状态不能被删除.',
    talkToTalent: '生产人员通话',
    talkToSession: '和接收机通话',
    talk: '通话',
    talking: '通话中',
    enableActiveFailed: '启动失败，至少要选择一个生产人员和一个的电台',
    longpressTips: '长按生效',
    addToIntercom: '添加到对讲室',
    activeSession: '主持人激活了会话',
    deactiveSession: '主持人停用了会话',
    webStationHasTalk: 'Web端电台{staionName}({sessionName}) 和你发起对话.',
    webStationEndTalk: 'Web端电台{staionName}({sessionName}) 已经结束和你的对话.',
    webUi: '网页端:',
    deviceVoIP: '设备通话:',
    pushTalkToStation: '主持人在和你对话.',
    pushTalkToStationEnd: '主持人已经结束了和你的对话.',
    pushToHost: '和主持人对话',
    quicklyOperation: '操作时间太短请重试.',
    on: '开启',
    off: '关闭',
    cannotTalkToTalent: '如果想开启和生产员通话请先关闭和接收机通话.',
    cannotTalkToTalentByTalkALL: '果想开启和生产员通话请先关闭和所有生产员通话',
    cannotTalkToSession: '如果想和接收机和生产员通话请先关闭和生产员通话.',
    cannotTalkToSessionByTalkAll: '如果想和接收机和生产员通话请先关闭和所有生产员通话',
    cannotTalkAllTalent: '如果你想和所有生产员通话请先停止会话中的和生产员通话或者是和会话内所有人通话.'
  }
}
